// extracted by mini-css-extract-plugin
export default {"wrapper":"Articles_wrapper__LPAPn","container":"Articles_container__g++r1","articleList":"Articles_articleList__iGEQ3"};